import { Component, input, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ObjectTypes } from '@src/suite/common/enums/object-types';

import { StoryIconComponent } from '../../components/icon/story-icon';

@Component({
    selector: 'st-record-mat-icon',
    imports: [MatIcon, StoryIconComponent],
    templateUrl: './record-mat-icon.html',
    styleUrl: './record-mat-icon.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-record-mat-icon',
    },
})
export class StFullScreenRecordIconComponent {
    ObjectTypesEnum = ObjectTypes;
    readonly recordType = input<ObjectTypes>();
    readonly subType = input<string>();
}
